import { Route, Switch, useRouteMatch } from "react-router";

import RegionCreate from "./RegionCreate";
import RegionsList from "./RegionsList";

const RegionsPage = (props) => {
    let { path } = useRouteMatch();
    return <Switch>
        <Route path={`${path}/create`}><RegionCreate {...props}/></Route>
        <Route path={`${path}/:id/preview`}><RegionsList {...props} /></Route>
        <Route exact path={path}><RegionsList {...props}/></Route>
    </Switch>;
}

export default RegionsPage;
